
import React, { useState, useEffect, useRef } from "react";

import "./QuestionHeader.css"

function QuestionHeader({isPlaying}) {


  // TODO: add soccer league images
  return (
    <>
      <header className="Question-header">
        Guess who am I?
      </header>
      <h3>{isPlaying ? "" : "loading ..."}</h3>
    </>
  );
}


export default QuestionHeader;